/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".grid-container[_ngcontent-%COMP%] {\r\n    display: -ms-grid;\r\n    display: grid;\r\n    height: 100%;\r\n    transition: all 0.5s ease-in-out; \r\n    \r\n}\r\n\r\n.grid-item[_ngcontent-%COMP%]{\r\n    border-radius: 5px;\r\n}\r\n\r\n.grid-item.hasBackground[_ngcontent-%COMP%] {\r\n    background-color: #fff;\r\n    \r\n    box-shadow:0 4px 8px 0 rgba(59,175,218, 0.4);\r\n}\r\n\r\n.grid-item.hasBackground[_ngcontent-%COMP%]:hover {\r\n    \r\n    box-shadow:0 4px 16px 0 rgba(59,175,218, 0.4);\r\n}"];
export { styles as styles };
